import { TFunction } from 'hooks/useI18n';
import { SectionHeroDataProps } from '../shared/sectionHero/SectionHero.types';
import { SwitcherProps } from '../shared/switcher/Switcher.types';
import AverageSalaryByRole from './AverageSalaryByRole';
import {
  AverageSalaryByFrameworksProps,
  AverageSalaryByLanguageProps,
  AverageSalaryByOtherProps,
  EnglishLevelDataProps,
  LocationDataProps
} from './Benefits.types';
import AverageSalaryByFrameworks from './charts/AverageSalaryByFrameworks';
import AverageSalaryByLanguage from './charts/AverageSalaryByLanguage';
import AverageSalaryByOther from './charts/AverageSalaryByOther';

export const HERODATA = (t: TFunction): SectionHeroDataProps[] => [
  {
    value: '62%',
    desc: t('mandecar23.benefits.hero.key-point-1')
  },
  {
    value: '€61-63K',
    desc: t('mandecar23.benefits.hero.key-point-2')
  },
  {
    value: '15%',
    desc: t('mandecar23.benefits.hero.key-point-3')
  },
  {
    value: '€10K',
    desc: t('mandecar23.benefits.hero.key-point-4')
  }
];

export const LOCATIONDATA = (t: TFunction): LocationDataProps[] => [
  {
    type: 'medium',
    value: 24.1,
    label: t('mandecar23.benefits.location.hybrid')
  },
  {
    type: 'big',
    value: 62.8,
    label: t('mandecar23.benefits.location.remote')
  },
  {
    type: 'small',
    value: 13.1,
    label: t('mandecar23.benefits.location.onsite')
  }
];

export const AVERAGESALARYTABS = (t: TFunction): SwitcherProps => ({
  tabsName: 'averageSalary',
  tabs: [
    {
      id: 'averageSalaryByLang',
      label: t('mandecar23.benefits.average-salary-language.languages'),
      content: <AverageSalaryByLanguage />
    },
    {
      id: 'averageSalaryByFrameworks',
      label: t('mandecar23.benefits.average-salary-language.frameworks'),
      content: <AverageSalaryByFrameworks />
    },
    {
      id: 'averageSalaryByOther',
      label: t('mandecar23.benefits.average-salary-language.other-techs'),
      content: <AverageSalaryByOther />
    }
  ]
});

export const AVERAGESALARYBYLANGUAGE = (
  locale: string | undefined
): AverageSalaryByLanguageProps[] => [
  {
    years: '<2',
    JavaScript: 26.959838585703306,
    PHP: 26.819565217391304,
    CSS: 26.44574175824176,
    HTML: 26.43994413407821,
    SQL: 28.589068825910932,
    Python: 29.57867412140575,
    JAVA: 27.71289537712895,
    'C#': 27.62465373961219,
    'C++': 29.438931297709924,
    TypeScript: 27.85395408163265
  },
  {
    years: '2-5',
    TypeScript: 38.89467312348668,
    PHP: 36.31507592190889,
    HTML: 35.78656639004149,
    Python: 42.17796143250689,
    SQL: 39.24448275862069,
    JAVA: 39.227914110429445,
    'C#': 37.68600682593856,
    JavaScript: 37.44172535211268,
    'C++': 41.14713896457766,
    CSS: 35.50954100051573
  },
  {
    years: '5-10',
    SQL: 51.44762757385855,
    JavaScript: 49.36,
    Python: 54.6529197080292,
    PHP: 45.411162790697674,
    'C#': 47.51067961165049,
    HTML: 46.754262416604895,
    CSS: 46.83733133433283,
    'C++': 49.72931034482759,
    TypeScript: 53.29372197309417,
    JAVA: 51.45797485109199
  },
  {
    years: '>10',
    PHP: 54.013531799729364,
    TypeScript: 63.37091988130564,
    'C#': 56.114285714285714,
    CSS: 52.28588516746411,
    Python: 62.07580445544554,
    'C++': 59.4404255319149,
    HTML: 52.479034810126585,
    SQL: 57.91475166790215,
    JavaScript: 57.33212457337884,
    JAVA: 61.70120537783959
  }
];

export const AVERAGESALARYBYFRAMEWORKS = (
  locale: string | undefined
): AverageSalaryByFrameworksProps[] => [
  {
    years: '<2',
    Express: 26.42365887207703,
    Laravel: 25.653333333333332,
    Spring: 27.896907216494846,
    Bootstrap: 25.704011065006913,
    React: 26.859365994236313,
    '.NET': 28.152694610778443,
    'Angular2+': 27.785067873303166,
    'Spring Boot': 27.022184300341298,
    Vue: 27.663352272727273,
    jQuery: 26.386699507389164
  },
  {
    years: '2-5',
    Vue: 38.31072555205047,
    'Angular2+': 38.11573033707865,
    Bootstrap: 33.195736434108525,
    React: 37.91451233842538,
    Laravel: 35.09718309859155,
    Spring: 39.434782608695656,
    jQuery: 34.673969072164944,
    '.NET': 38.53879310344828,
    Express: 35.97525773195876,
    'Spring Boot': 39.83684210526316
  },
  {
    years: '5-10',
    Vue: 50.138297872340424,
    Spring: 50.978794642857146,
    'Spring Boot': 52.065217391304344,
    jQuery: 43.91222222222222,
    Express: 50.329787234042556,
    Laravel: 43.700854700854705,
    '.NET': 47.550970873786405,
    'Angular2+': 48.41112385321101,
    Bootstrap: 43.24153846153846,
    React: 52.19280762564991
  },
  {
    years: '>10',
    '.NET': 56.145596590909086,
    React: 61.713592233009706,
    Laravel: 51.528443113772454,
    'Angular2+': 56.67426273458445,
    Spring: 59.56613372093023,
    Express: 55.743718592964825,
    'Spring Boot': 61.59615384615385,
    jQuery: 49.23575129533678,
    Vue: 56.761904761904766,
    Bootstrap: 48.349184782608695
  }
];

export const AVERAGESALARYBYOTHER = (
  locale: string | undefined
): AverageSalaryByOtherProps[] => [
  {
    years: '<2',
    PostgreSQL: 27.906370656370655,
    Docker: 29.947674418604652,
    Linux: 28.109686609686612,
    Github: 26.27342747111682,
    MongoDB: 27.574262461851475,
    Jira: 28.406779661016948,
    MySQL: 26.878155339805826,
    AWS: 32.54166666666667,
    NodeJS: 27.079699248120303,
    Git: 26.969317199654277
  },
  {
    years: '2-5',
    NodeJS: 38.49175412293853,
    AWS: 44.96009975062344,
    Git: 38.42718446601942,
    MySQL: 37.55349794238683,
    Docker: 42.66425702811245,
    Linux: 39.56391585760518,
    PostgreSQL: 40.45155502392344,
    Jira: 40.41526520051747,
    MongoDB: 39.076146788990826,
    Github: 37.737381703470035
  },
  {
    years: '5-10',
    Git: 50.1992125984252,
    MySQL: 47.91726332537788,
    Linux: 49.91185897435898,
    NodeJS: 51.55740037950664,
    MongoDB: 52.10184182015168,
    PostgreSQL: 53.20475561426684,
    Jira: 50.63279301745636,
    AWS: 58.11670235546039,
    Docker: 54.03792025019546,
    Github: 53.264642082429496
  },
  {
    years: '>10',
    Github: 63.18678815489749,
    NodeJS: 60.59712230215827,
    Jira: 61.195097037793666,
    Git: 57.13106796116505,
    PostgreSQL: 61.17013129102845,
    MongoDB: 60.85735735735736,
    Docker: 63.84983818770226,
    Linux: 57.38914233576642,
    AWS: 69.12688821752266,
    MySQL: 56.29779874213837
  }
];

export const AVERAGESALARYBYROLE = [
  {
    role: 'Product Manager',
    tier1: 0.3129890453834116,
    tier2: 6.964006259780908,
    tier3: 16.118935837245697,
    tier4: 26.76056338028169,
    tier5: 21.439749608763695,
    tier6: 20.81377151799687,
    tier7: 7.589984350547731
  },
  {
    role: 'Backend Developer',
    tier1: 7.648828516728963,
    tier2: 22.764153523566414,
    tier3: 23.393199015407056,
    tier4: 21.1869814932993,
    tier5: 12.507977026164646,
    tier6: 9.0801349256997,
    tier7: 3.209043668520376
  },
  {
    role: 'Data Scientist',
    tier1: 5.278810408921933,
    tier2: 22.527881040892193,
    tier3: 23.04832713754647,
    tier4: 19.925650557620816,
    tier5: 14.79553903345725,
    tier6: 9.144981412639405,
    tier7: 4.907063197026022
  },
  {
    role: 'Engineering Management',
    tier1: 0.8784773060029283,
    tier2: 3.001464128843338,
    tier3: 7.46705710102489,
    tier4: 14.568081991215227,
    tier5: 21.2298682284041,
    tier6: 30.74670571010249,
    tier7: 21.59590043923865
  },
  {
    role: 'Full-stack Developer',
    tier1: 8.706022659511031,
    tier2: 28.133571854502087,
    tier3: 23.446630888491356,
    tier4: 18.962432915921287,
    tier5: 10.447227191413237,
    tier6: 7.740011926058438,
    tier7: 2.409063804412641
  },
  {
    role: 'Data Analysis & BI',
    tier1: 6.0382916053019144,
    tier2: 23.711340206185564,
    tier3: 23.711340206185564,
    tier4: 21.354933726067745,
    tier5: 13.25478645066274,
    tier6: 8.24742268041237,
    tier7: 3.4609720176730487
  },
  {
    role: 'DevOps & Infra. & SRE',
    tier1: 2.7791814047498735,
    tier2: 11.874684183931278,
    tier3: 15.866599292572007,
    tier4: 22.132390096008084,
    tier5: 19.252147549267306,
    tier6: 19.55533097524002,
    tier7: 8.388074785245074
  },
  {
    role: 'Tech Lead',
    tier1: 0.6058158319870759,
    tier2: 1.4539579967689822,
    tier3: 7.95638126009693,
    tier4: 21.08239095315024,
    tier5: 24.919224555735056,
    tier6: 29.563812600969307,
    tier7: 14.095315024232633
  },
  {
    role: 'SysAdmin',
    tier1: 4.151838671411625,
    tier2: 22.064056939501782,
    tier3: 28.46975088967972,
    tier4: 20.640569395017792,
    tier5: 13.523131672597867,
    tier6: 7.947805456702254,
    tier7: 2.9655990510083043
  },
  {
    role: 'QA & Testing Engineer',
    tier1: 7.588739290085679,
    tier2: 27.41738066095471,
    tier3: 25.458996328029375,
    tier4: 17.38066095471236,
    tier5: 12.851897184822523,
    tier6: 6.609547123623011,
    tier7: 2.2031823745410035
  },
  {
    role: 'Product Design (UI/UX)',
    tier1: 6.013179571663921,
    tier2: 35.749588138385505,
    tier3: 30.724876441515654,
    tier4: 16.556836902800658,
    tier5: 6.507413509060955,
    tier6: 2.9654036243822075,
    tier7: 1.400329489291598
  },
  {
    role: 'Project & Delivery Manager',
    tier1: 0.41284403669724773,
    tier2: 7.844036697247707,
    tier3: 16.376146788990827,
    tier4: 25.963302752293576,
    tier5: 22.06422018348624,
    tier6: 22.477064220183486,
    tier7: 4.81651376146789
  },
  {
    role: 'Frontend Developer',
    tier1: 12.58826393961529,
    tier2: 33.19941563184806,
    tier3: 22.58339420501583,
    tier4: 15.497930362795229,
    tier5: 8.375943511078646,
    tier6: 5.746286827367909,
    tier7: 1.8261504747991235
  },
  {
    role: 'Software Architect',
    tier1: 2.2087244616234125,
    tier2: 6.018774157923799,
    tier3: 9.99447818884594,
    tier4: 20.706791827719492,
    tier5: 23.743787962451684,
    tier6: 24.29596907785754,
    tier7: 12.534511319712866
  },
  {
    role: 'Data Engineer',
    tier1: 3.8724373576309796,
    tier2: 30.220197418375093,
    tier3: 22.39939255884586,
    tier4: 19.665907365223994,
    tier5: 17.084282460136674,
    tier6: 15.261958997722095,
    tier7: 6.302201974183751
  },
  {
    role: 'Mobile Developer',
    tier1: 9.57193816884661,
    tier2: 22.05707491082045,
    tier3: 21.284185493460168,
    tier4: 19.738406658739596,
    tier5: 13.3769322235434,
    tier6: 10.523186682520809,
    tier7: 3.2699167657550534
  }
];

// TODO: Build a selector with the experience and get the right data from this object applying a filter over the 'exp' property
export const SALARYRANGEBYROLEANDEXPERIENCE = [
  {
    role: 'Backend Developer',
    exp: '0-0',
    tier1: 28.65221489161169,
    tier2: 46.842601319509896,
    tier3: 9.142318567389255,
    tier4: 6.4090480678605095,
    tier5: 3.2045240339302548,
    tier6: 2.9217719132893496,
    tier7: 2.35626767200754
  },
  {
    role: 'Backend Developer',
    exp: '10-',
    tier1: 0.2570694087403599,
    tier2: 3.2317297098788105,
    tier3: 15.754682335659197,
    tier4: 29.59970620639001,
    tier5: 23.28314359162688,
    tier6: 20.16158648549394,
    tier7: 7.601909658464928
  },
  {
    role: 'Backend Developer',
    exp: '-2',
    tier1: 19.80295566502463,
    tier2: 57.487684729064036,
    tier3: 17.733990147783253,
    tier4: 3.0049261083743843,
    tier5: 0.7389162561576355,
    tier6: 0.6896551724137931,
    tier7: 0.24630541871921183
  },
  {
    role: 'Backend Developer',
    exp: '2-5',
    tier1: 3.870254330998894,
    tier2: 21.85772207887947,
    tier3: 39.43973461113159,
    tier4: 22.152598599336528,
    tier5: 8.219683007740509,
    tier6: 3.3910799852561744,
    tier7: 0.9583486914854404
  },
  {
    role: 'Backend Developer',
    exp: '5-10',
    tier1: 0.9005321326238231,
    tier2: 6.2218583708555055,
    tier3: 24.96930004093328,
    tier4: 32.255423659435124,
    tier5: 19.0749079001228,
    tier6: 12.68931641424478,
    tier7: 3.643061809250921
  },
  {
    role: 'Data Analysis & BI',
    exp: '0-0',
    tier1: 20.32967032967033,
    tier2: 42.857142857142854,
    tier3: 18.13186813186813,
    tier4: 7.6923076923076925,
    tier5: 5.4945054945054945,
    tier6: 3.296703296703297,
    tier7: 2.197802197802198
  },
  {
    role: 'Data Analysis & BI',
    exp: '10-',
    tier1: 0.6211180124223602,
    tier2: 2.7950310559006213,
    tier3: 14.906832298136646,
    tier4: 29.503105590062113,
    tier5: 22.049689440993788,
    tier6: 22.36024844720497,
    tier7: 7.453416149068323
  },
  {
    role: 'Data Analysis & BI',
    exp: '2-5',
    tier1: 2.0172910662824206,
    tier2: 19.88472622478386,
    tier3: 33.429394812680115,
    tier4: 26.801152737752158,
    tier5: 12.103746397694524,
    tier6: 3.170028818443804,
    tier7: 2.5936599423631126
  },
  {
    role: 'Data Analysis & BI',
    exp: '5-10',
    tier1: 0.4444444444444444,
    tier2: 7.555555555555555,
    tier3: 23.555555555555554,
    tier4: 32.44444444444444,
    tier5: 23.11111111111111,
    tier6: 9.333333333333334,
    tier7: 3.5555555555555554
  },
  {
    role: 'Data Analysis & BI',
    exp: '-2',
    tier1: 12.411347517730496,
    tier2: 52.4822695035461,
    tier3: 25.886524822695034,
    tier4: 5.319148936170213,
    tier5: 1.773049645390071,
    tier6: 0.7092198581560284,
    tier7: 0.7092198581560284
  },
  {
    role: 'Data Engineer',
    exp: '0-0',
    tier1: 20.535714285714285,
    tier2: 36.607142857142854,
    tier3: 23.214285714285715,
    tier4: 7.142857142857142,
    tier5: 4.464285714285714,
    tier6: 3.571428571428571,
    tier7: 3.571428571428571
  },
  {
    role: 'Data Engineer',
    exp: '10-',
    tier1: 0.3134796238244514,
    tier2: 2.8213166144200628,
    tier3: 8.463949843260188,
    tier4: 21.630094043887148,
    tier5: 20.06269592476489,
    tier6: 32.288401253918494,
    tier7: 14.106583072100314
  },
  {
    role: 'Data Engineer',
    exp: '-2',
    tier1: 7.964601769911504,
    tier2: 41.5929203539823,
    tier3: 38.49557522123894,
    tier4: 6.1946902654867255,
    tier5: 2.2123893805309733,
    tier6: 0.8849557522123894,
    tier7: 2.212389380530974
  },
  {
    role: 'Data Engineer',
    exp: '2-5',
    tier1: 1.5544041450777202,
    tier2: 12.694300518134716,
    tier3: 31.865284974093267,
    tier4: 25.906735751295333,
    tier5: 17.616580310880828,
    tier6: 8.290155440414509,
    tier7: 1.8134715025906738
  },
  {
    role: 'Data Engineer',
    exp: '5-10',
    tier1: 1.094890510948905,
    tier2: 2.18978102189781,
    tier3: 11.678832116788321,
    tier4: 24.817518248175183,
    tier5: 30.29197080291971,
    tier6: 21.897810218978105,
    tier7: 8.02919708029197
  },
  {
    role: 'Data Scientist',
    exp: '10-',
    tier1: 0.4629629629629629,
    tier2: 3.2407407407407405,
    tier3: 7.87037037037037,
    tier4: 25.925925925925924,
    tier5: 20.833333333333336,
    tier6: 25,
    tier7: 15.74074074074074
  },
  {
    role: 'Data Scientist',
    exp: '2-5',
    tier1: 1.1990407673860912,
    tier2: 15.347721822541965,
    tier3: 30.69544364508393,
    tier4: 27.098321342925658,
    tier5: 16.546762589928058,
    tier6: 6.71462829736211,
    tier7: 2.1582733812949644
  },
  {
    role: 'Data Scientist',
    exp: '5-10',
    tier1: 1.2987012987012987,
    tier2: 5.194805194805195,
    tier3: 15.584415584415584,
    tier4: 25.108225108225106,
    tier5: 30.303030303030305,
    tier6: 15.151515151515152,
    tier7: 7.359307359307359
  },
  {
    role: 'Data Scientist',
    exp: '0-0',
    tier1: 19.393939393939394,
    tier2: 40,
    tier3: 24.242424242424242,
    tier4: 9.090909090909092,
    tier5: 3.6363636363636362,
    tier6: 1.8181818181818181,
    tier7: 1.2121212121212122
  },
  {
    role: 'Data Scientist',
    exp: '-2',
    tier1: 9.49367088607595,
    tier2: 48.41772151898734,
    tier3: 28.48101265822785,
    tier4: 8.227848101265822,
    tier5: 2.848101265822785,
    tier6: 0.949367088607595,
    tier7: 1.2658227848101267
  },
  {
    role: 'DevOps & Infra. & SRE',
    exp: '0-0',
    tier1: 18.556701030927837,
    tier2: 29.896907216494846,
    tier3: 9.278350515463918,
    tier4: 9.278350515463918,
    tier5: 15.463917525773196,
    tier6: 11.34020618556701,
    tier7: 6.185567010309278
  },
  {
    role: 'DevOps & Infra. & SRE',
    exp: '10-',
    tier1: 0,
    tier2: 2.857142857142857,
    tier3: 8.181818181818182,
    tier4: 21.948051948051948,
    tier5: 23.376623376623375,
    tier6: 28.96103896103896,
    tier7: 14.545454545454545
  },
  {
    role: 'DevOps & Infra. & SRE',
    exp: '2-5',
    tier1: 2.9484029484029484,
    tier2: 13.513513513513514,
    tier3: 28.746928746928745,
    tier4: 27.27272727272727,
    tier5: 16.953316953316953,
    tier6: 7.616707616707617,
    tier7: 2.9484029484029484
  },
  {
    role: 'DevOps & Infra. & SRE',
    exp: '5-10',
    tier1: 0.6048387096774194,
    tier2: 3.8306451612903225,
    tier3: 15.32258064516129,
    tier4: 25.806451612903224,
    tier5: 23.18548387096774,
    tier6: 23.991935483870968,
    tier7: 7.056451612903226
  },
  {
    role: 'DevOps & Infra. & SRE',
    exp: '-2',
    tier1: 10.526315789473683,
    tier2: 52.63157894736842,
    tier3: 22.966507177033492,
    tier4: 10.047846889952153,
    tier5: 1.4354066985645932,
    tier6: 1.4354066985645932,
    tier7: 0.4784688995215311
  },
  {
    role: 'Engineering Management',
    exp: '0-0',
    tier1: 11.363636363636363,
    tier2: 13.636363636363635,
    tier3: 9.090909090909092,
    tier4: 15.909090909090908,
    tier5: 15.909090909090908,
    tier6: 15.909090909090908,
    tier7: 15.909090909090908
  },
  {
    role: 'Engineering Management',
    exp: '10-',
    tier1: 0.1128668171557562,
    tier2: 0.6772009029345373,
    tier3: 3.724604966139955,
    tier4: 12.302483069977427,
    tier5: 19.63882618510158,
    tier6: 36.681715575620764,
    tier7: 26.410835214446955
  },
  {
    role: 'Engineering Management',
    exp: '2-5',
    tier1: 2.8301886792452833,
    tier2: 11.320754716981133,
    tier3: 26.41509433962264,
    tier4: 24.528301886792452,
    tier5: 23.58490566037736,
    tier6: 7.547169811320755,
    tier7: 3.7735849056603774
  },
  {
    role: 'Engineering Management',
    exp: '5-10',
    tier1: 0,
    tier2: 1.3468013468013467,
    tier3: 10.1010101010101,
    tier4: 17.50841750841751,
    tier5: 26.936026936026934,
    tier6: 26.936026936026934,
    tier7: 16.835016835016834
  },
  {
    role: 'Engineering Management',
    exp: '-2',
    tier1: 8.823529411764707,
    tier2: 38.23529411764706,
    tier3: 20.588235294117645,
    tier4: 14.705882352941178,
    tier5: 11.76470588235294,
    tier6: 0,
    tier7: 2.941176470588235
  },
  {
    role: 'Frontend Developer',
    exp: '0-0',
    tier1: 31.29432624113475,
    tier2: 53.28014184397163,
    tier3: 7.624113475177305,
    tier4: 2.925531914893617,
    tier5: 2.039007092198582,
    tier6: 1.2411347517730498,
    tier7: 1.2411347517730498
  },
  {
    role: 'Frontend Developer',
    exp: '10-',
    tier1: 0.7832898172323759,
    tier2: 5.047867711053089,
    tier3: 19.321148825065272,
    tier4: 30.374238468233244,
    tier5: 21.23585726718886,
    tier6: 17.667536988685814,
    tier7: 5.395996518711923
  },
  {
    role: 'Frontend Developer',
    exp: '-2',
    tier1: 24.365256124721604,
    tier2: 59.10913140311804,
    tier3: 12.605790645879733,
    tier4: 2.271714922048998,
    tier5: 0.5345211581291759,
    tier6: 0.7572383073496659,
    tier7: 0.17817371937639198
  },
  {
    role: 'Frontend Developer',
    exp: '2-5',
    tier1: 4.910509407985315,
    tier2: 28.54520422212024,
    tier3: 39.375860486461676,
    tier4: 17.622762735199633,
    tier5: 6.287287746672786,
    tier6: 2.2946305644791187,
    tier7: 0.8260670032124828
  },
  {
    role: 'Frontend Developer',
    exp: '5-10',
    tier1: 1.1896893588896233,
    tier2: 7.865168539325842,
    tier3: 26.834104428288168,
    tier4: 30.138797091870455,
    tier5: 17.97752808988764,
    tier6: 12.425644415069398,
    tier7: 3.4368803701255786
  },
  {
    role: 'Full-stack Developer',
    exp: '0-0',
    tier1: 26.53288740245262,
    tier2: 55.18394648829431,
    tier3: 8.695652173913043,
    tier4: 4.3478260869565215,
    tier5: 1.89520624303233,
    tier6: 2.118171683389075,
    tier7: 1.1148272017837235
  },
  {
    role: 'Full-stack Developer',
    exp: '10-',
    tier1: 0.4194128220491312,
    tier2: 3.59496704613541,
    tier3: 16.117435590173756,
    tier4: 30.437387657279807,
    tier5: 22.768124625524266,
    tier6: 19.952067106051526,
    tier7: 6.411024565608148
  },
  {
    role: 'Full-stack Developer',
    exp: '-2',
    tier1: 19.729307652264445,
    tier2: 60.3331598125976,
    tier3: 15.668922436231131,
    tier4: 2.6028110359187924,
    tier5: 0.4685059864653826,
    tier6: 0.8328995314940135,
    tier7: 0.20822488287350338
  },
  {
    role: 'Full-stack Developer',
    exp: '2-5',
    tier1: 4.240447343895619,
    tier2: 24.79030754892824,
    tier3: 39.60857409133271,
    tier4: 19.757688723205966,
    tier5: 7.409133271202236,
    tier6: 2.9356943150046595,
    tier7: 1.1183597390493942
  },
  {
    role: 'Full-stack Developer',
    exp: '5-10',
    tier1: 0.8561643835616438,
    tier2: 6.449771689497717,
    tier3: 26.71232876712329,
    tier4: 32.47716894977169,
    tier5: 17.751141552511417,
    tier6: 12.442922374429223,
    tier7: 3.2534246575342465
  },
  {
    role: 'Mobile Developer',
    exp: '0-0',
    tier1: 36,
    tier2: 42.66666666666667,
    tier3: 8,
    tier4: 6,
    tier5: 4,
    tier6: 1.3333333333333335,
    tier7: 2
  },
  {
    role: 'Mobile Developer',
    exp: '10-',
    tier1: 0.29239766081871343,
    tier2: 2.046783625730994,
    tier3: 15.789473684210526,
    tier4: 27.192982456140353,
    tier5: 25.730994152046783,
    tier6: 20.760233918128655,
    tier7: 7.894736842105263
  },
  {
    role: 'Mobile Developer',
    exp: '2-5',
    tier1: 4.326923076923077,
    tier2: 21.153846153846153,
    tier3: 35.33653846153847,
    tier4: 23.798076923076923,
    tier5: 8.89423076923077,
    tier6: 4.807692307692308,
    tier7: 1.6826923076923077
  },
  {
    role: 'Mobile Developer',
    exp: '5-10',
    tier1: 1.3729977116704806,
    tier2: 4.576659038901601,
    tier3: 22.19679633867277,
    tier4: 27.91762013729977,
    tier5: 21.052631578947366,
    tier6: 18.306636155606405,
    tier7: 4.118993135011442
  },
  {
    role: 'Mobile Developer',
    exp: '-2',
    tier1: 24.556213017751478,
    tier2: 56.80473372781065,
    tier3: 14.201183431952662,
    tier4: 2.6627218934911245,
    tier5: 0.591715976331361,
    tier6: 1.183431952662722,
    tier7: 0
  },
  {
    role: 'Product Design (UI/UX)',
    exp: '2-5',
    tier1: 2.1671826625387,
    tier2: 41.17647058823529,
    tier3: 39.628482972136226,
    tier4: 12.38390092879257,
    tier5: 2.786377708978328,
    tier6: 0.9287925696594427,
    tier7: 0.9287925696594428
  },
  {
    role: 'Product Design (UI/UX)',
    exp: '0-0',
    tier1: 16.666666666666664,
    tier2: 55.26315789473685,
    tier3: 16.666666666666664,
    tier4: 5.263157894736842,
    tier5: 1.7543859649122806,
    tier6: 1.7543859649122806,
    tier7: 2.631578947368421
  },
  {
    role: 'Product Design (UI/UX)',
    exp: '-2',
    tier1: 17.338709677419356,
    tier2: 62.5,
    tier3: 16.129032258064516,
    tier4: 2.82258064516129,
    tier5: 0,
    tier6: 0.4032258064516129,
    tier7: 0.4032258064516129
  },
  {
    role: 'Product Design (UI/UX)',
    exp: '10-',
    tier1: 1.1152416356877324,
    tier2: 13.011152416356877,
    tier3: 32.342007434944236,
    tier4: 28.624535315985128,
    tier5: 15.241635687732341,
    tier6: 7.434944237918216,
    tier7: 2.2304832713754648
  },
  {
    role: 'Product Design (UI/UX)',
    exp: '5-10',
    tier1: 0.38461538461538464,
    tier2: 18.461538461538463,
    tier3: 38.07692307692307,
    tier4: 27.307692307692307,
    tier5: 10.384615384615385,
    tier6: 3.8461538461538463,
    tier7: 1.5384615384615385
  },
  {
    role: 'Product Manager',
    exp: '0-0',
    tier1: 0,
    tier2: 15.789473684210526,
    tier3: 21.052631578947366,
    tier4: 21.052631578947366,
    tier5: 22.807017543859647,
    tier6: 7.017543859649122,
    tier7: 12.280701754385964
  },
  {
    role: 'Product Manager',
    exp: '10-',
    tier1: 0.1949317738791423,
    tier2: 1.1695906432748537,
    tier3: 7.602339181286549,
    tier4: 20.857699805068226,
    tier5: 24.561403508771928,
    tier6: 33.91812865497076,
    tier7: 11.695906432748536
  },
  {
    role: 'Product Manager',
    exp: '2-5',
    tier1: 0.3448275862068966,
    tier2: 12.068965517241379,
    tier3: 28.965517241379313,
    tier4: 29.310344827586203,
    tier5: 18.620689655172416,
    tier6: 7.586206896551724,
    tier7: 3.103448275862069
  },
  {
    role: 'Product Manager',
    exp: '5-10',
    tier1: 0,
    tier2: 3.361344537815126,
    tier3: 14.565826330532214,
    tier4: 36.134453781512605,
    tier5: 21.84873949579832,
    tier6: 18.487394957983195,
    tier7: 5.602240896358543
  },
  {
    role: 'Product Manager',
    exp: '-2',
    tier1: 3.278688524590164,
    tier2: 44.26229508196721,
    tier3: 31.147540983606557,
    tier4: 14.754098360655737,
    tier5: 4.918032786885246,
    tier6: 0,
    tier7: 1.639344262295082
  },
  {
    role: 'Project & Delivery Manager',
    exp: '10-',
    tier1: 0,
    tier2: 1.864406779661017,
    tier3: 8.64406779661017,
    tier4: 22.966101694915253,
    tier5: 27.033898305084747,
    tier6: 32.45762711864407,
    tier7: 6.9491525423728815
  },
  {
    role: 'Project & Delivery Manager',
    exp: '2-5',
    tier1: 0.9036144578313252,
    tier2: 28.313253012048197,
    tier3: 33.433734939759034,
    tier4: 31.32530120481928,
    tier5: 13.855421686746988,
    tier6: 5.120481927710843,
    tier7: 1.2048192771084338
  },
  {
    role: 'Project & Delivery Manager',
    exp: '5-10',
    tier1: 0.3952569169960474,
    tier2: 6.126482213438735,
    tier3: 20.35573122529644,
    tier4: 33.794466403162055,
    tier5: 19.76284584980237,
    tier6: 16.40316205533597,
    tier7: 3.162055335968379
  },
  {
    role: 'Project & Delivery Manager',
    exp: '0-0',
    tier1: 3.75,
    tier2: 26.25,
    tier3: 22.5,
    tier4: 18.75,
    tier5: 16.25,
    tier6: 8.75,
    tier7: 3.75
  },
  {
    role: 'Project & Delivery Manager',
    exp: '-2',
    tier1: 1.2195121951219512,
    tier2: 60.97560975609756,
    tier3: 28.04878048780488,
    tier4: 6.097560975609756,
    tier5: 3.6585365853658534,
    tier6: 0,
    tier7: 0
  },
  {
    role: 'QA & Testing Engineer',
    exp: '10-',
    tier1: 1.092896174863388,
    tier2: 5.46448087431694,
    tier3: 16.939890710382514,
    tier4: 30.05464480874317,
    tier5: 25.136612021857925,
    tier6: 17.48633879781421,
    tier7: 3.825136612021858
  },
  {
    role: 'QA & Testing Engineer',
    exp: '2-5',
    tier1: 3.524229074889868,
    tier2: 26.87224669603524,
    tier3: 41.409691629955944,
    tier4: 16.299559471365637,
    tier5: 7.488986784140969,
    tier6: 1.3215859030837005,
    tier7: 2.643171806167401
  },
  {
    role: 'QA & Testing Engineer',
    exp: '5-10',
    tier1: 1.1560693641618496,
    tier2: 15.028901734104046,
    tier3: 27.167630057803464,
    tier4: 21.965317919075144,
    tier5: 21.38728323699422,
    tier6: 10.404624277456648,
    tier7: 2.312138728323699
  },
  {
    role: 'QA & Testing Engineer',
    exp: '0-0',
    tier1: 23.456790123456788,
    tier2: 53.086419753086425,
    tier3: 12.345679012345679,
    tier4: 3.7037037037037033,
    tier5: 3.7037037037037033,
    tier6: 1.2345679012345678,
    tier7: 1.2345679012345678
  },
  {
    role: 'QA & Testing Engineer',
    exp: '-2',
    tier1: 20.26143790849673,
    tier2: 54.90196078431373,
    tier3: 16.99346405228758,
    tier4: 5.88235294117647,
    tier5: 1.3071895424836601,
    tier6: 0,
    tier7: 0
  },
  {
    role: 'Software Architect',
    exp: '0-0',
    tier1: 15.18987341772152,
    tier2: 18.9873417721519,
    tier3: 12.658227848101266,
    tier4: 11.39240506329114,
    tier5: 10.126582278481013,
    tier6: 24.050632911392405,
    tier7: 7.594936708860759
  },
  {
    role: 'Software Architect',
    exp: '10-',
    tier1: 0.11148272017837235,
    tier2: 1.1148272017837235,
    tier3: 3.2329988851727984,
    tier4: 18.61761426978818,
    tier5: 27.201783723522855,
    tier6: 31.995540691192865,
    tier7: 17.16833890746934
  },
  {
    role: 'Software Architect',
    exp: '2-5',
    tier1: 3.4220532319391634,
    tier2: 11.787072243346007,
    tier3: 27.756653992395435,
    tier4: 29.277566539923956,
    tier5: 16.34980988593156,
    tier6: 6.844106463878327,
    tier7: 4.182509505703422
  },
  {
    role: 'Software Architect',
    exp: '5-10',
    tier1: 0,
    tier2: 1.5350877192982455,
    tier3: 6.578947368421052,
    tier4: 25,
    tier5: 28.947368421052634,
    tier6: 25.219298245614034,
    tier7: 12.280701754385964
  },
  {
    role: 'Software Architect',
    exp: '-2',
    tier1: 15.517241379310345,
    tier2: 39.6551724137931,
    tier3: 33.62068965517241,
    tier4: 6.896551724137931,
    tier5: 2.586206896551724,
    tier6: 0.8620689655172413,
    tier7: 0
  },
  {
    role: 'SysAdmin',
    exp: '0-0',
    tier1: 23.52941176470588,
    tier2: 37.254901960784316,
    tier3: 9.803921568627452,
    tier4: 11.76470588235294,
    tier5: 11.76470588235294,
    tier6: 1.9607843137254901,
    tier7: 3.9215686274509802
  },
  {
    role: 'SysAdmin',
    exp: '10-',
    tier1: 1.1494252873563218,
    tier2: 8.333333333333332,
    tier3: 26.72413793103448,
    tier4: 25.862068965517242,
    tier5: 20.114942528735632,
    tier6: 13.218390804597702,
    tier7: 4.310344827586206
  },
  {
    role: 'SysAdmin',
    exp: '2-5',
    tier1: 1.7857142857142856,
    tier2: 30.357142857142854,
    tier3: 39.88095238095239,
    tier4: 18.452380952380953,
    tier5: 7.142857142857142,
    tier6: 1.7857142857142856,
    tier7: 0.5952380952380952
  },
  {
    role: 'SysAdmin',
    exp: '5-10',
    tier1: 1.5789473684210527,
    tier2: 20,
    tier3: 30.526315789473685,
    tier4: 22.63157894736842,
    tier5: 13.684210526315791,
    tier6: 7.894736842105263,
    tier7: 3.6842105263157894
  },
  {
    role: 'SysAdmin',
    exp: '-2',
    tier1: 15.11627906976744,
    tier2: 56.97674418604651,
    tier3: 19.767441860465116,
    tier4: 4.651162790697675,
    tier5: 0,
    tier6: 2.3255813953488373,
    tier7: 0
  },
  {
    role: 'Tech Lead',
    exp: '0-0',
    tier1: 3.1746031746031744,
    tier2: 6.349206349206349,
    tier3: 7.936507936507936,
    tier4: 23.809523809523807,
    tier5: 12.698412698412698,
    tier6: 28.57142857142857,
    tier7: 17.46031746031746
  },
  {
    role: 'Tech Lead',
    exp: '10-',
    tier1: 0.21994134897360706,
    tier2: 0.5131964809384164,
    tier3: 4.618768328445748,
    tier4: 17.082111436950147,
    tier5: 25.806451612903224,
    tier6: 33.94428152492669,
    tier7: 17.44868035190616
  },
  {
    role: 'Tech Lead',
    exp: '2-5',
    tier1: 3.292181069958848,
    tier2: 3.7037037037037033,
    tier3: 20.5761316872428,
    tier4: 31.275720164609055,
    tier5: 24.691358024691358,
    tier6: 11.11111111111111,
    tier7: 5.349794238683128
  },
  {
    role: 'Tech Lead',
    exp: '5-10',
    tier1: 0.1287001287001287,
    tier2: 1.1583011583011582,
    tier3: 8.622908622908623,
    tier4: 24.967824967824967,
    tier5: 25.225225225225223,
    tier6: 28.57142857142857,
    tier7: 11.068211068211067
  },
  {
    role: 'Tech Lead',
    exp: '-2',
    tier1: 3.4482758620689653,
    tier2: 24.137931034482758,
    tier3: 41.37931034482759,
    tier4: 13.793103448275861,
    tier5: 3.4482758620689653,
    tier6: 6.896551724137931,
    tier7: 3.4482758620689653
  }
];

export const AVERAGESALARYBYENGLISHLEVEL = (
  t: TFunction
): EnglishLevelDataProps[] => [
  {
    level: t('mandecar23.benefits.english.basic'),
    tier1: 17.322432294328053,
    tier2: 27.491057741440983,
    tier3: 20.0817577925396,
    tier4: 17.322432294328053,
    tier5: 7.153806847215124,
    tier6: 4.496678589678078,
    tier7: 2.1972406745017885
  },
  {
    level: t('mandecar23.benefits.english.intermediate'),
    tier1: 11.227839789888378,
    tier2: 23.5281243160429,
    tier3: 19.43532501641497,
    tier4: 19.107025607353904,
    tier5: 12.103304880717882,
    tier6: 7.7040927992996275,
    tier7: 3.2173342087984245
  },
  {
    level: t('mandecar23.benefits.english.fluent'),
    tier1: 5.757696921231507,
    tier2: 17.712914834066375,
    tier3: 17.293082766893242,
    tier4: 16.11355457816873,
    tier5: 13.894442223110756,
    tier6: 14.814074370251898,
    tier7: 11.175529788084765
  },
  {
    level: t('mandecar23.benefits.english.native'),
    tier1: 5.061349693251533,
    tier2: 16.411042944785276,
    tier3: 14.877300613496933,
    tier4: 11.65644171779141,
    tier5: 10.276073619631902,
    tier6: 13.496932515337424,
    tier7: 21.319018404907975
  }
];

export const AVERAGESALARYBYROLEANDEXPERIENCETABS = (
  t: TFunction
): SwitcherProps => ({
  label: t('mandecar23.benefits.average-salary-role.experience'),
  tabsName: 'averageSalaryByRoleAndExperience',
  tabs: [
    {
      id: 'exp-2',
      label: '<2 ' + t('mandecar23.benefits.average-salary-role.years'),
      content: <AverageSalaryByRole experience="-2" />
    },
    {
      id: 'exp2-5',
      label: '2-5 ' + t('mandecar23.benefits.average-salary-role.years'),
      content: <AverageSalaryByRole experience="2-5" />
    },
    {
      id: 'exp5-10',
      label: '5-10 ' + t('mandecar23.benefits.average-salary-role.years'),
      content: <AverageSalaryByRole experience="5-10" />
    },
    {
      id: 'exp+10',
      label: '>10 ' + t('mandecar23.benefits.average-salary-role.years'),
      content: <AverageSalaryByRole experience="10-" />,
      defaultChecked: true
    }
  ]
});
